<template>
  <v-footer
      id="pageFooter"
      class="p-3"
      padless
  >
    <div class="row mr-8">
      <div class="col-auto">
        <i class="fa-brands fa-cc-amazon-pay font24px transform-icon"></i>
        <span class="pr-2">پرداخت امن </span>
      </div>
      <div class="col-auto">
        <i class="fa-solid fa-headphones font24px transform-icon"></i>
        <span class="pr-2">پشتیبانی 24 ساعته </span>
      </div>
      <div class="col-auto">
        <i class="fa-solid fa-comments-question-check font24px transform-icon"></i>
        <span class="pr-2">مشاوره رایگان </span>
      </div>
    </div>

    <div class="row border-top-primary">
      <div class="col">
        <router-link class="mb-4" to="/">
          <img :src="getImgUrl('footerLogo.jpg')" alt="لوگو ایوان خانه" height="40"/>
        </router-link>
        <div class="d-flex flex-column">

          <router-link class="my-2" to="AboutUs">
            درباره ما
          </router-link>
          <router-link class="my-2" to="ConnectUs">
            تماس با ما
          </router-link>
          <router-link class="my-2" to="RulesOfRegulation">
            قوانین و مقرارات و حریم خصوصی
          </router-link>
          <router-link v-if="isLoggedIn" class="my-2" to="CriticsAndSuggestions">
            انتقادات و پیشنهادات
          </router-link>
          <span v-else class="my-2" @click="showNeedLogin">

            انتقادات و پیشنهادات
          </span>
          <router-link class="my-2" to="FAQ">
            سوالات متداول
          </router-link>
          <router-link class="my-2" to="Support">
            پشتیبانی
          </router-link>
        </div>
      </div>
      <div class="col">
        <h6 class="mb-5">مطالب مفید</h6>
        <div class="d-flex flex-column">
          <router-link class="my-2" to="NewsesList">
            اخبار
          </router-link>
          <router-link class="my-2" to="ArticlesList">
            مقالات
          </router-link>
          <router-link class="my-2" to="ReviewsList">
            نقد و بررسی
          </router-link>
        </div>
      </div>
      <div class="col">
        <h6 class="mb-5">خدمات</h6>
        <div class="d-flex flex-column">
          <router-link class="my-2" to="OnlinePaymentHome">
            فروشگاه با پرداخت آنلاین
          </router-link>
          <router-link class="my-2" to="OfflinePaymentHome">
            فروشگاه با پرداخت آفلاین
          </router-link>
          <router-link class="my-2" to="ConnectUs">
            شبکه اجتماعی
          </router-link>
        </div>
      </div>
      <div class="col">
        <h6 class="mb-5">ارتباط با ما</h6>
        <div class="d-flex flex-column">
          <div class="my-2 pointer" @click="openPhone('02177896985')">
            <div class="d-flex justify-space-between">
              <div><i class="fa-regular fa-phone-volume font18px"></i></div>
              <div>02177896985</div>
            </div>
          </div>
          <div class="my-2 pointer" @click="openPhone('09358171304')">
            <div class="d-flex justify-space-between">
              <div><i class="fa-regular fa-comment-sms font18px"></i></div>
              <div>09358171304</div>
            </div>
          </div>
          <div class="my-2 pointer" @click="$openLink('mailto:' + 'Info@eyvankhaneh.com')">
            <div class="d-flex justify-space-between">
              <div><i class="fa-regular fa-envelope font18px ml-6"></i></div>
              <div class="font12px">Info@eyvankhaneh.com</div>
            </div>
          </div>
          <div class="my-2 pointer" @click="openPhone('09358171304')">
            <div class="d-flex justify-space-between">
              <div><i class="fa-solid fa-headphones font18px"></i></div>
              <div>09358171304</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-auto pl-1" style="max-width: 120px">
        <h6 class="mb-5">شبکه اجتماعی</h6>
    <div class="row">
      <div class="col-6 p-1 text-center " v-for="(item,i) in socialLinks" :key="i">
        <a :href="item.Link" target="_blank">
          <v-avatar size="35">
            <img :src="$replaceHttps(item.FileUrl)">
          </v-avatar>
        </a>
      </div>
    </div>
      </div>
      <div class="col text-center pr-1">
        <h6 class="mb-5">اپلیکیشین اندروید</h6>
        <div  class="row">
          <div class="col-12 text-center  flex-column d-flex py-0 justify-content-center align-items-center">
            <img :src="getImgUrl('googlePlay.svg')"  width="150" alt="گوگل پلی" >
            <img :src="getImgUrl('mayket.svg')" class="my-5"  width="150" alt="گوگل پلی">
            <img :src="getImgUrl('bazar.png')"   width="150" alt="گوگل پلی" >
          </div>
        </div>
      </div>

    </div>
    <div class="row">
      <div class="col-12 text-center py-0">طراح: <span> شرکت ایده زرین پرهام</span></div>
      <div class="col-12 text-center pb-0">تمامی حقوق وبسایت محفوظ و در اختیار <span> ایوانخانه </span> میباشد.</div>
    </div>
    <v-snackbar
        v-model="showResult"
        :multi-line="true"
        color="primary"    >
      <div v-html="resultText"></div>

      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" icon @click="showResult = false ">
          <i class="fa-solid fa-circle-xmark fa-xl white--text"></i>
        </v-btn>
      </template>
    </v-snackbar>
  </v-footer>
</template>

<script>
export default {
  name: "Footer",
  data: () => ({
    icons: [
      'mdi-facebook',
      'mdi-twitter',
      'mdi-linkedin',
      'mdi-instagram',
    ],
    isLoggedIn:false,
    showResult:false,
    resultText:'',
    socialLinks:null
  }),
  mounted() {
    this.isLoggedIn = this.$store.getters.getIsLoggedIn
    this.getSocialLinks()

  },
  methods: {
    getImgUrl(pic) {
      return require("../assets/img/" + pic);
    },
    showNeedLogin(){
      this.resultText='برای مشاهده این بخش باید وارد شوید'
      this.showResult=true
    },
    getSocialLinks(){
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Publicly/LocalSocialNetwork", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.socialLinks = JSON.parse(result)
          })
          .catch(error => console.log('error', error));
    },
    openPhone(tel) {
      this.$openLink("tel:" + tel)
    },
  }
}
</script>

<style scoped>

</style>
